import React from 'react';
import  ReactDOM  from 'react-dom';
import Card from './Card';
import Chess from './Chess.jsx';
ReactDOM.render(
  <>
  <Card/>
  <Chess/>
  </>,
  document.getElementById("root")
);